export default __webpack_public_path__ + "static/media/Workshop_18A5549-min.998333e9.jpg";